import { useTranslation } from "react-i18next";
import { BemessungssituationState } from "../../../../store/slices/innereSlice";
import { RowBody } from "../../../../components/RowValue/RowBody";

function OperationDuration({ value }) {
  const { t } = useTranslation("translation");

  function renderBemessungssituation(val) {
    switch (val) {
      case BemessungssituationState.DAUERHAFT:
        return t("inner.permanent");
      case BemessungssituationState.TEMPORÄR:
        return t("inner.temporary");
      default:
        return "";
    }
  }

  return (
    <RowBody
      titleValue={<p>{t("lvText.positionMicropiles.operationDuration")}</p>}
      inputValue={<span className="input">{renderBemessungssituation(value)}</span>}
    />
  );
}

export default OperationDuration;
